function getToken() {
  let token = localStorage.getItem("charlie-otr-token");
  const config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "content-type": "application/json",
      Pragma: "no-cache",
      token: token
    }
  };
  return config;
}

export { getToken };
